import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryWarehouse as SchemaDeliveryWarehouse } from '../schemas/DeliveryWarehouse';
import { type DeliveryWarehouseCourierInfo as SchemaDeliveryWarehouseCourierInfo } from '../schemas/DeliveryWarehouseCourierInfo';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const UpdateDeliveryWarehouseByIdContentType = 'application/json' as const;
export type UpdateDeliveryWarehouseByIdRequest = {
    /**
     * @example Склад №1
     */
    title: string;
    courier_info: SchemaDeliveryWarehouseCourierInfo;
};
export type UpdateDeliveryWarehouseByIdResponses = LinkCommonErrorResponses & {
    /**
     * @description Warehouse updated
     */
    '200': {
        'application/json': SchemaDeliveryWarehouse;
    };
};
export type UpdateDeliveryWarehouseByIdResponseSuccess =
    UpdateDeliveryWarehouseByIdResponses['200']['application/json'];
export type UpdateDeliveryWarehouseByIdSearchParams = undefined;
export type UpdateDeliveryWarehouseByIdPathParameters = {
    warehouse_id: string;
};
export const UpdateDeliveryWarehouseByIdUrl = '/delivery/warehouse/{warehouse_id}' as const;
export const UpdateDeliveryWarehouseByIdMethod = 'PATCH' as const;
export const getUpdateDeliveryWarehouseByIdUrl = (params: UpdateDeliveryWarehouseByIdPathParameters) =>
    UpdateDeliveryWarehouseByIdUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof UpdateDeliveryWarehouseByIdPathParameters) => String(params[param])
    );
